import { render, staticRenderFns } from "./Testimonial.vue?vue&type=template&id=1cef285a&scoped=true"
import script from "./Testimonial.vue?vue&type=script&lang=js"
export * from "./Testimonial.vue?vue&type=script&lang=js"
import style0 from "./Testimonial.vue?vue&type=style&index=0&id=1cef285a&prod&scoped=true&lang=css"
import style1 from "./Testimonial.vue?vue&type=style&index=1&id=1cef285a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cef285a",
  null
  
)

export default component.exports